import * as THREE from "three"
import { Vector2, Vector3, Mesh, Geometry, Renderer } from "./three.d"
import { Item, Point2D } from "../../../lib/ForceDirectedGraph"

let R = 10
let r = 3

export const setTorusDimensions = (_R: number, _r: number): void => {
  R = _R
  r = _r
}

export const getUnitHexagon2d = (): Vector2[] => {
  const points = []
  for (let angle = 0; angle < 2 * Math.PI; angle += Math.PI / 3) {
    const vertex = new THREE.Vector2(Math.cos(angle), Math.sin(angle))
    points.push(vertex)
  }
  return points
}

const unitHexagon = getUnitHexagon2d()

export const projectOntoTorus = (theta: number, phi: number): Vector3 => {
  const major = R + r * Math.cos(phi)
  return new THREE.Vector3(
    major * Math.cos(theta),
    r * Math.sin(phi),
    major * Math.sin(theta)
  )
}

export const getHexagonGeometry = (
  positionTheta: number,
  positionPhi: number,
  sizeTheta: number,
  sizePhi: number
): Geometry => {
  const geom = new THREE.Geometry()

  geom.vertices.push(projectOntoTorus(positionTheta, positionPhi))

  const uvs = [new THREE.Vector2(0.5, 0.5)]

  unitHexagon.forEach(vertex => {
    geom.vertices.push(
      projectOntoTorus(
        positionTheta + sizeTheta * vertex.x,
        positionPhi + sizePhi * vertex.y
      )
    )
    uvs.push(new THREE.Vector2(0.5 - 0.5 * vertex.x, 0.5 - 0.5 * vertex.y))
  })

  for (let i = 1; i <= 6; i++) {
    const face = new THREE.Face3(0, i, i + 1)
    geom.faces.push(face)
    geom.faceVertexUvs[0].push([uvs[0], uvs[i], uvs[i + 1]])
  }

  return geom
}

const hexagonGeometry = getHexagonGeometry()

export const hexagonMeshForImage = (
  imageUrl: string,
  renderer: Renderer
): Mesh => {
  var texture = new THREE.TextureLoader().load(imageUrl)
  texture.anisotropy = renderer.getMaxAnisotropy()

  var material = new THREE.MeshBasicMaterial({
    map: texture,
  })

  return new THREE.Mesh(hexagonGeometry, material)
}

export const meshForGeometryAndImage = (
  geometry: Geometry,
  imageUrl: string,
  renderer: Renderer
): Mesh => {
  const lineMaterial = new THREE.LineBasicMaterial({
    color: 0x666666,
    linewidth: 1,
    linecap: "round", //ignored by WebGLRenderer
    linejoin: "round", //ignored by WebGLRenderer
  })

  const mesh = new THREE.Mesh(geometry, lineMaterial)
  mesh.onBeforeRender = function() {
    if (!this.hasRendered) {
      var texture = new THREE.TextureLoader().load(imageUrl)
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy()

      var material = new THREE.MeshBasicMaterial({
        map: texture,
      })

      this.material = material
      this.hasRendered = true
    }
  }
  return mesh
}

export const projectVectorOntoTorus = (vec: Point2D): Vector3 => {
  const major = R + r * Math.cos(vec.y)
  return new THREE.Vector3(
    major * Math.cos(vec.x),
    r * Math.sin(vec.y),
    major * Math.sin(vec.x)
  )
}
